import React, { forwardRef, useState } from 'react';

import { Box, Typography, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import { CustomButton } from '../../../../components/UI/CustomButton';
import { LearnerInfo, Team } from '../../../../types';
import useStyles from '../CreateTeamModal/styles';

interface ChangeLearnerTeamModalProps {
  learner?: LearnerInfo | null;
  teams?: Team[];
  onChangeTeam: Function;
  setLeaveModal: Function;
  currentTeam?: Team | null;
}

const ChangeLearnerTeamModal: React.FC<ChangeLearnerTeamModalProps> = forwardRef<
  HTMLDivElement,
  ChangeLearnerTeamModalProps & React.HTMLProps<HTMLDivElement>
>(({ teams, learner, onChangeTeam, setLeaveModal, currentTeam }, ref) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [team, setTeam] = useState<Team | null>(currentTeam || null);
  const [teamErr, setTeamErr] = useState('');

  const handleChangeTeam = () => {
    if (!team) {
      setTeamErr(t('error.fieldRequired'));
      return;
    }
    if (team.id === currentTeam?.id) return;
    onChangeTeam({
      variables: {
        input: {
          from_team: currentTeam?.id,
          id: learner?.id,
          to_team: team?.id,
        },
      },
    });
  };

  return (
    <div ref={ref} className={classes.container}>
      <Box className={classes.modal}>
        <CloseIcon className={classes.modalCloseBtn} onClick={() => setLeaveModal(false)} />
        <Typography variant="h3">
          {t('page.account.changeTeamFor', { learner: learner?.name })}
        </Typography>
        <Box className={classes.modalContent}>
          <Autocomplete
            options={teams || []}
            getOptionLabel={(option) => option?.name || ''}
            value={team}
            onChange={(event, value) => {
              if (value) {
                setTeamErr('');
              }
              setTeam(value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name="team"
                variant="outlined"
                label={t('page.assignedLearnings.team')}
                error={!!teamErr}
                helperText={teamErr}
                className={classes.formField}
              />
            )}
          />
        </Box>
        <Box>
          <CustomButton
            btnClass={cx(classes.cancelBtn, classes.btn)}
            onClick={() => setLeaveModal(false)}
            color="secondary"
          >
            {t('button.cancel')}
          </CustomButton>
          <CustomButton btnClass={classes.btn} onClick={handleChangeTeam}>
            {t('button.change')}
          </CustomButton>
        </Box>
      </Box>
    </div>
  );
});

export default ChangeLearnerTeamModal;
